module.exports = __webpack_public_path__ + "img/8.4.NH3-N.f6222019.png";